import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { PageHero } from "./AboutPage";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

export default function ServicesPage() {
  const { services, L } = useSite();
  return (
    <main data-testid="services-page">
      <Seo title={PAGE_SEO.services.title} description={PAGE_SEO.services.description} path="/services" />
      <PageHero overline={L.servicesPage.overline} title={L.servicesPage.title}
        subtitle={L.servicesPage.subtitle} />
      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.06}>
              <div className="group bg-white border border-slate-200 hover:shadow-xl transition-shadow duration-300 overflow-hidden h-full flex flex-col">
                <div className="h-52 overflow-hidden">
                  <img src={`${imgUrl(s.image)}?w=800&q=70`} alt={`${s.title} in Huntsville, AL — Noyola Construction`} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <h2 className="font-heading font-bold text-[#0B1B3D] text-xl mb-2">{s.title}</h2>
                  <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-1">{s.description}</p>
                  <div className="flex items-center justify-between">
                    <Link to={`/services/${s.slug}`} data-testid={`service-detail-link-${s.slug}`}
                      className="inline-flex items-center gap-2 text-[#0B1B3D] font-heading font-bold uppercase tracking-widest text-xs hover:text-[#005AE0] transition-colors">
                      {L.servicesSec.details} <ArrowRight className="w-3.5 h-3.5" />
                    </Link>
                    <Link to={`/estimate?service=${encodeURIComponent(s.title)}`} data-testid={`service-estimate-btn-${s.slug}`}
                      className="btn-primary !py-2.5 !px-4 !text-[11px]">{L.servicesSec.request}</Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
